import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AdminTabs from '../../components/Admin/AdminTabs';
import ConfirmModal from '../../components/common/ConfirmModal';
import Header from '../../components/common/Header';
import MainMenuDrawer from '../../components/Main/MenuDrawer';
import { getAdminServiceLinksApi, updateAdminServiceLinksApi } from '../../api';

const ServiceLinkManagement = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const [serviceLinks, setServiceLinks] = useState({
    telegram: '',
    kakao: '',
    youtube: '',
    passwordFind: '',
  });
  const [serviceLinksBaseline, setServiceLinksBaseline] = useState({
    telegram: '',
    kakao: '',
    youtube: '',
    passwordFind: '',
  });
  const [savingServiceLinks, setSavingServiceLinks] = useState(false);
  const [serviceLinksSavedOpen, setServiceLinksSavedOpen] = useState(false);
  const [confirmServiceLinksSaveOpen, setConfirmServiceLinksSaveOpen] = useState(false);

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await getAdminServiceLinksApi();
        const items = res?.data || [];
        const next = {
          telegram: '',
          kakao: '',
          youtube: '',
          passwordFind: '',
        };
        for (const it of items) {
          if (it?.key && Object.prototype.hasOwnProperty.call(next, it.key)) {
            next[it.key] = it.url || '';
          }
        }
        if (alive) {
          setServiceLinks(next);
          setServiceLinksBaseline(next);
        }
      } catch (e) {
        if (e?.status === 401 || e?.suppressAlert) return;
        if (alive) alert(e?.message || '이동 주소 정보를 불러오지 못했습니다.');
      } finally {
        // no-op
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  const handleSaveServiceLinks = async () => {
    try {
      setSavingServiceLinks(true);
      await updateAdminServiceLinksApi(serviceLinks);
      setServiceLinksBaseline(serviceLinks);
      setServiceLinksSavedOpen(true);
    } catch (e) {
      if (e?.status === 401 || e?.suppressAlert) return;
      alert(e?.message || '이동 주소 저장에 실패했습니다.');
    } finally {
      setSavingServiceLinks(false);
    }
  };

  const handleCancelServiceLinks = () => {
    setServiceLinks(serviceLinksBaseline);
  };

  const isServiceLinksDirty =
    JSON.stringify(serviceLinks) !== JSON.stringify(serviceLinksBaseline);

  return (
    <Box>
      <Box
        sx={{
          maxWidth: 430,
          mx: 'auto',
          bgcolor: 'white',
          minHeight: '100vh',
          borderRadius: 0,
          boxShadow: '0 0 20px rgba(0,0,0,0.06)',
          px: 2,
          pb: 2,
          position: 'relative',
        }}
      >
        <ConfirmModal
          open={serviceLinksSavedOpen}
          message="수정되었습니다."
          confirmText="확인"
          onConfirm={() => setServiceLinksSavedOpen(false)}
        />
        <ConfirmModal
          open={confirmServiceLinksSaveOpen}
          message="수정하시겠습니까?"
          confirmText="수정"
          cancelText="취소"
          onConfirm={() => {
            setConfirmServiceLinksSaveOpen(false);
            handleSaveServiceLinks();
          }}
          onCancel={() => setConfirmServiceLinksSaveOpen(false)}
        />

        <MainMenuDrawer
          open={menuOpen}
          onClose={() => setMenuOpen(false)}
          onNavigate={handleNavigate}
        />

        <Header variant="full" onClickMenu={() => setMenuOpen(true)} />

        <AdminTabs />

        <Box sx={{ mt: 2 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {[
              { key: 'telegram', label: '텔레그램' },
              { key: 'kakao', label: '카카오톡' },
              { key: 'youtube', label: '유튜브' },
              { key: 'passwordFind', label: '비밀번호 찾기' },
            ].map((f) => (
              <Box key={f.key}>
                <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 0.75 }}>
                  {f.label}
                </Typography>
                <Box
                  sx={{
                    border: '1px solid #e0e0e0',
                    borderRadius: 1,
                    px: 1.25,
                    py: 1.1,
                    bgcolor: 'white',
                  }}
                >
                  <input
                    type="text"
                    style={{
                      width: '100%',
                      border: 'none',
                      outline: 'none',
                      fontSize: 13,
                    }}
                    value={serviceLinks[f.key] || ''}
                    disabled={savingServiceLinks}
                    onChange={(e) =>
                      setServiceLinks((p) => ({
                        ...p,
                        [f.key]: e.target.value,
                      }))
                    }
                  />
                </Box>
              </Box>
            ))}
          </Box>

          <Box sx={{ display: 'flex', gap: 1, mt: 3 }}>
            <Button
              fullWidth
              variant="outlined"
              onClick={handleCancelServiceLinks}
              disabled={savingServiceLinks || !isServiceLinksDirty}
              sx={{
                borderColor: '#ddd',
                color: '#333',
                fontWeight: 700,
                height: 44,
                '&.Mui-disabled': { borderColor: '#eee', color: '#bbb' },
              }}
            >
              취소
            </Button>
            <Button
              fullWidth
              variant="contained"
              onClick={() => setConfirmServiceLinksSaveOpen(true)}
              disabled={savingServiceLinks || !isServiceLinksDirty}
              sx={{
                bgcolor: '#103c85',
                fontWeight: 700,
                height: 44,
                boxShadow: 'none',
                '&:hover': { bgcolor: '#0d3170', boxShadow: 'none' },
                '&.Mui-disabled': { bgcolor: '#d0d7e6', color: 'white' },
              }}
            >
              수정
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ServiceLinkManagement;


